/**
 * Returns a random integer in `[min, max]` that is not already in `usedNumbers`.
 * The returned value is added to `usedNumbers` as a side effect.
 * @param min - Inclusive lower bound.
 * @param max - Inclusive upper bound.
 * @param usedNumbers - Set of integers to exclude; mutated in place.
 */
export const getRandomInt = (min: number, max: number, usedNumbers: Set<number> = new Set<number>()): number => {
	min = Math.ceil(min)
	max = Math.floor(max)

	let randomNum: number

	do {
		randomNum = Math.floor(Math.random() * (max - min + 1) + min)
	} while (usedNumbers.has(randomNum))

	usedNumbers.add(randomNum)

	return randomNum
}

/**
 * Returns up to `max` randomly selected items from `items` without replacement.
 * If `items.length <= max`, the whole array is returned (shuffled copy).
 * @param items - Source array to sample from.
 * @param max - Maximum number of items to pick.
 */
export const pickRandomNumbers = <T>(items: T[], max: number): T[] => {
	if (items.length <= max) return [...items]

	const shuffled = [...items].sort(() => Math.random() - 0.5)
	return shuffled.slice(0, max)
}
